var map = {
	"./icon-add-active.svg": "6012",
	"./icon-add.svg": "b0dc",
	"./icon-delete-active.svg": "31d5",
	"./icon-delete.svg": "e265",
	"./icon-edit-active.svg": "a180",
	"./icon-edit.svg": "25fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "404c";